import { render, staticRenderFns } from "./ModalSolicitacaoLaudo.vue?vue&type=template&id=2fd4ad2e&lang=pug"
import script from "./ModalSolicitacaoLaudo.vue?vue&type=script&lang=js"
export * from "./ModalSolicitacaoLaudo.vue?vue&type=script&lang=js"
import style0 from "./ModalSolicitacaoLaudo.vue?vue&type=style&index=0&id=2fd4ad2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports